@if(isLoading) {
    <div class="loader-wrapper" [@fadeInOnEnter] [@fadeOutOnLeave]>
        <div class="loaderCircle"></div>
        <div class="loader-content">
            <p-progressSpinner strokeWidth="8" 
            fill="transparent" 
            animationDuration=".5s"
            [style]="{ width: '50px', height: '50px' }" />

            <div class="loader-text">{{loaderText | translate}}</div>
        </div>
        
    </div>
    
}

